__turbopack_context__.v({
  "qrCode": "appdownloadmodal-module-scss-module__HZcNtq__qrCode",
  "qrSection": "appdownloadmodal-module-scss-module__HZcNtq__qrSection",
});
